import { supabase } from '../lib/supabase';

export const paymentService = {
  async createCheckoutSession(priceId, userId) {
    const { data, error } = await supabase?.functions?.invoke('create-checkout-session', {
      body: {
        priceId,
        userId
      }
    });

    if (error) throw error;
    return data;
  },

  async getSubscriptionStatus(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('subscription_status, subscription_end_date')?.eq('id', userId)?.single();

    if (error) throw error;
    return data;
  },

  formatAmount(amount, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    })?.format(amount / 100);
  }
};